import styled from "styled-components";

import * as Accordion from "ds/Accordion";
import { Input, Label } from "ds/Radio";
import { Tooltip } from "ds/Tooltip";
import { breakpoints } from "Libs/theme";

// TODO sketchy rules
export const FilterSection = styled.div`
  > * {
    width: 224px;
  }
  @media (max-width: ${breakpoints[1]}) {
    > * {
      width: 100%;
    }
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 16px 0;
  h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
  }
  button {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const InputInfrastructure = styled(Input)`
  ${Label} {
    font-size: 14px;
    font-weight: 400;
    color: var(--section-ebony-color, var(--ebony));
  }
`;

export const Fake = styled(Accordion.FakeLabel)<{ disabled: boolean }>`
  ${props =>
    props.disabled && `color: var(--section-granite-color, var(--granite));`};
`;

export const FilterNumber = styled.span`
  color: var(--section-slate-color, var(--slate));
`;

export const DedicatedContent = styled(Tooltip.Content)<{ disabled: boolean }>`
  visibility: ${props => (props.disabled ? "hidden" : "visible")};
`;

export const ListCheckboxItem = styled(Accordion.ListCheckboxItem)`
  align-items: center;

  label {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--section-ebony-color, var(--ebony));
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const Icon = styled.div`
  flex: 0;
  margin-left: 4px;
  margin-top: 4px;
`;

export const RegionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
